module.exports = __webpack_public_path__ + "pallyy-image-e6caa4f7d022b24d4c769d7679c4f55f.webp";